import React from 'react';
import { Dialog, CircularProgress, Typography, Button } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { CategoryService } from './categoryService';
import { UniqueNonEmptyValidator } from '../utils/uniqueNonEmptyValidator';
import { CategoryDialogTabGeneral } from './categoryDialogTabGeneral';
import { CategoryDialogTabInspectionAttributes } from './categoryDialogTabInspectionAttributes';
import { CategoryDialogTabMaintenanceAttributes } from './categoryDialogTabMaintenanceAttributes';

const STATUS = {
  IDLE: 'IDLE',
  SUBMITTING: 'SUBMITTING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

export class CategoryDialogButton extends React.Component {
    constructor (props) {
        super(props);

        const { categoryData } = props;

        this.state = {
            tabValue: 0,
            isDialogOpen: false,
            inspectionAttributes: null,
            maintenanceAttributes: null,
            categoryData,
            status: STATUS.IDLE,
            errorMessage: ''
        };
    }

    handleDialogOpen = () => {
        const { categoryId, categoryData } = this.props;

        this.setState({
            tabValue: 0,
            isDialogOpen: true,
            inspectionAttributes: null,
            maintenanceAttributes: null,
            categoryData,
            status: STATUS.IDLE,
            errorMessage: ''
        });

        CategoryService.listInspectionAttributes(categoryId).then(inspectionAttributes => this.setState({ inspectionAttributes }));
        CategoryService.listMaintenanceAttributes(categoryId).then(maintenanceAttributes => this.setState({ maintenanceAttributes }));
    };

    closeDialog = () => this.setState({ isDialogOpen: false });

    handleSubmit = () => {
        const { onSubmit } = this.props;
        const { categoryData, inspectionAttributes, maintenanceAttributes } = this.state;

        this.setState({ status: STATUS.SUBMITTING });

        onSubmit(categoryData, inspectionAttributes, maintenanceAttributes)
            .then(() => {
                this.setState({ status: STATUS.SUCCESS });
                setTimeout(this.closeDialog, 1500); // Fecha automaticamente após 1.5 segundos
            })
            .catch(error => {
                this.setState({ 
                    status: STATUS.ERROR,
                    errorMessage: error.message 
                });
            });
    };

    updateState = (stateData) => this.setState(state => stateData);

    renderStatusContent = () => {
        const { status, errorMessage, categoryData } = this.state;
        const { currentLanguage } = this.props;

        switch (status) {
            case STATUS.SUBMITTING:
                return (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <CircularProgress size={60} />
                        <Typography variant="h6" style={{ marginTop: '1rem' }}>
                            Salvando {categoryData.name}...
                        </Typography>
                    </div>
                );
            
            case STATUS.SUCCESS:
                return (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ color: 'green' }}>
                            Categoria salva com sucesso!
                        </Typography>
                    </div>
                );
            
            case STATUS.ERROR:
                return (
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <Typography variant="h6" style={{ color: 'red', marginBottom: '1rem' }}>
                            {errorMessage}
                        </Typography>
                        <Button 
                            variant="contained" 
                            color="primary"
                            onClick={() => this.setState({ status: STATUS.IDLE })}
                        >
                            Tentar novamente
                        </Button>
                    </div>
                );
            
            default:
                return this.showTabContent();
        }
    };

    showTabContent = () => {
        const { submitLabel, currentLanguage } = this.props;
        const { tabValue, categoryData, inspectionAttributes, maintenanceAttributes } = this.state;

        const inspectionAttributesValidator = UniqueNonEmptyValidator.ofNullable(inspectionAttributes, 'name');
        const maintenanceAttributesValidator = UniqueNonEmptyValidator.ofNullable(maintenanceAttributes, 'name');

        const validInspectionAttributes = inspectionAttributesValidator.isAllValidAndNonEmpty();
        const validMaintenanceAttributes = maintenanceAttributesValidator.isAllValidAndNonEmpty();

        switch (tabValue) {
            case 0: return (
                <CategoryDialogTabGeneral
                    currentLanguage={currentLanguage}
                    submitLabel={submitLabel}
                    categoryData={categoryData}
                    allValidAndNonEmpty={validInspectionAttributes && validMaintenanceAttributes}
                    closeDialog={this.closeDialog}
                    handleSubmit={this.handleSubmit}
                    updateState={this.updateState}
                />
            );
            case 1: return (
                <CategoryDialogTabInspectionAttributes
                    submitLabel={submitLabel}
                    inspectionAttributes={inspectionAttributes}
                    allValidAndNonEmpty={validInspectionAttributes && validMaintenanceAttributes}
                    inspectionAttributesValidator={inspectionAttributesValidator}
                    closeDialog={this.closeDialog}
                    handleSubmit={this.handleSubmit}
                    updateState={this.updateState}
                />
            );
            case 2: return (
                <CategoryDialogTabMaintenanceAttributes
                    submitLabel={submitLabel}
                    maintenanceAttributes={maintenanceAttributes}
                    allValidAndNonEmpty={validInspectionAttributes && validMaintenanceAttributes}
                    maintenanceAttributesValidator={maintenanceAttributesValidator}
                    closeDialog={this.closeDialog}
                    handleSubmit={this.handleSubmit}
                    updateState={this.updateState}
                />
            );
            default: throw new Error(`unimplemented: ${tabValue}`);
        }
    };

    render () {
        const { tabValue, isDialogOpen, status } = this.state;
        const { ModalButton, currentLanguage } = this.props;

        return (
            <React.Fragment>
                <ModalButton onClick={this.handleDialogOpen} />
                <Dialog 
                    open={isDialogOpen} 
                    onClose={this.closeDialog} 
                    fullWidth={true} 
                    maxWidth="md"
                    disableBackdropClick={status === STATUS.SUBMITTING}
                    disableEscapeKeyDown={status === STATUS.SUBMITTING}
                >
                    {status === STATUS.IDLE && (
                        <Tabs value={tabValue} onChange={(event, tabValue) => this.setState({ tabValue })}>
                            <Tab style={{ color: 'white' }} label={currentLanguage.general_information} />
                        </Tabs>
                    )}
                    {this.renderStatusContent()}
                </Dialog>
            </React.Fragment>
        );
    }
}

